import { render, staticRenderFns } from "./FormGuest.vue?vue&type=template&id=04f68d4e&scoped=true&"
import script from "./FormGuest.vue?vue&type=script&lang=js&"
export * from "./FormGuest.vue?vue&type=script&lang=js&"
import style0 from "./FormGuest.vue?vue&type=style&index=0&id=04f68d4e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04f68d4e",
  null
  
)

export default component.exports